import React from "react";
import Moment from "react-moment";
import { Box, Grid, Typography } from "@mui/material";

interface Props {
  field: string;
  value: any;
  isDateField?: boolean;
  fullwidth?: boolean;
}

export const CardItem = ({ field, value, isDateField = false, fullwidth = false }: Props) => {
  return (
    <Grid container item direction="row" xs={fullwidth ? 12 : 6} md={fullwidth ? 12 : 6}>
      <Grid item xs={fullwidth ? 3 : 5} md={fullwidth ? 2 : 5}>
        <Box color="text.secondary">
          <Typography>{`${field}: `}</Typography>
        </Box>
      </Grid>
      <Grid item xs={fullwidth ? 9 : 5} md={fullwidth ? 10 : 7}>
        <Box color="text.primary" ml={fullwidth ? "30px" : "inherit"}>
          {isDateField && value != null ? (
            <Typography>
              <Moment local={true} format="MM/DD/YYYY hh:mm A" date={value} />
            </Typography>
          ) : (
            <Typography>{value}</Typography>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};
